"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DeliveryMode = /** @class */ (function () {
    function DeliveryMode() {
    }
    DeliveryMode.Bridged = "bridged";
    DeliveryMode.Unbridged = "unbridged";
    return DeliveryMode;
}());
exports.default = DeliveryMode;
//# sourceMappingURL=DeliveryMode.js.map